import { makeStyles } from '@material-ui/core';

const styles = makeStyles((_theme) => ({
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    position: 'relative',
  },
  bulkButton: {
    textTransform: 'none',
    color: '#005abb',
    fontSize: 13,
    marginLeft: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
  filtersButton: {
    marginTop: 35,
  },
  filtersPopover: {
    padding: 20,
    width: 500,
  },
}));

export default styles;
